const palette = {
  primary: {
    main: "#EA5E42",
    contastText: "#ffffff",
  },
  secondary: {
    main: "#303D4A",
    contastText: "#ffffff",
  },
  text: {
    primary: "#000000",
    
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
